import { Component, Input } from '@angular/core';
import { FormControl, FormGroup } from '@angular/forms';
import { Router } from '@angular/router';
import { ClassToggleService } from '@coreui/angular';

// import { ClassToggleService, HeaderComponent } from '@coreui/angular';
import { TokenStorageService } from 'src/app/services/token-storage.service';
import { UserService } from 'src/app/services/user.service';

@Component({
  selector: 'app-header',
  templateUrl: './header.component.html',
})
export class HeaderComponent {
  @Input() sidebarId: string = 'sidebar';

  public newMessages = new Array(4);
  public newTasks = new Array(5);
  public newNotifications = new Array(5);

  constructor(
    private classToggler: ClassToggleService,
    private tokenStorageService: TokenStorageService,
    private userService: UserService,
    private router: Router
  ) {
  }

  logout(): void {
    // Revoke the DB-backed session and clear the HttpOnly cookies server-side;
    // clear local state either way so the UI never gets stuck "logged in" on a network error.
    this.userService.logout().subscribe({
      next: () => this.finishLogout(),
      error: () => this.finishLogout(),
    });
  }

  private finishLogout(): void {
    this.tokenStorageService.signOut();
    this.router.navigate(['/login']);
  }
}
